module.exports = __webpack_public_path__ + "static/media/verset_corner_upper_right.aa4aadda.png";